<template>
  <Transition
    enter-active-class="transition-all duration-300 ease-out"
    enter-from-class="opacity-0 translate-y-3 scale-90"
    enter-to-class="opacity-100 translate-y-0 scale-100"
    leave-active-class="transition-all duration-200 ease-in"
    leave-from-class="opacity-100 translate-y-0 scale-100"
    leave-to-class="opacity-0 translate-y-3 scale-90"
  >
    <button
      v-show="visible"
      @click="scrollToTop"
      type="button"
      aria-label="Volver arriba"
      title="Volver arriba"
      class="fixed z-30 bg-bochas-azul text-white rounded-full p-3 shadow-2xl shadow-black/50 ring-1 ring-white/10 active:scale-90 transition-transform touch-manipulation"
      :class="positionClasses"
    >
      <ChevronUp :size="22" :stroke-width="2.5" />
    </button>
  </Transition>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue";
import { ChevronUp } from "lucide-vue-next";

const props = defineProps({
  /** Px de scroll a partir de los cuáles aparece el botón. */
  threshold: { type: Number, default: 300 },
});

const visible = ref(false);
let ticking = false;

function onScroll() {
  // throttle con rAF para no spamear el reactive update en mobile
  if (ticking) return;
  ticking = true;
  window.requestAnimationFrame(() => {
    visible.value = window.scrollY > props.threshold;
    ticking = false;
  });
}

function scrollToTop() {
  // Para usuarios con prefers-reduced-motion, salta sin animación.
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  window.scrollTo({ top: 0, behavior: reduced ? "auto" : "smooth" });
}

// Posición: respeta safe-area de iOS (bottom + right). Mismo offset para
// mobile y desktop — la idea es que el botón viva en la esquina inferior-derecha.
const positionClasses = computed(
  () =>
    "bottom-[calc(1.25rem+var(--safe-bottom))] right-[calc(1.25rem+var(--safe-right))]",
);

onMounted(() => {
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll(); // sync inicial (por si el user carga la página con scroll heredado)
});

onUnmounted(() => {
  window.removeEventListener("scroll", onScroll);
});
</script>
